
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.67 0h-8.054c.433 2.657 3.031 5.143 5.89 5.143h6.408c.086-.257.086-.6.086-.857C42 1.886 40.095 0 37.67 0z","fill":"url(#paint0_linear_8972_158095)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.31 5.571V12h3.898V8.57h3.464c1.905 0 3.55-1.285 4.07-3H30.311zM16.454 0v12h3.464s.866 0 1.3-.857l3.03-6h.433V12h3.897V0h-3.464s-.866.086-1.299.857l-3.03 6h-.434V0h-3.897zM0 12V0h3.897S5.023 0 5.63 1.714c1.559 4.543 1.732 5.143 1.732 5.143s.347-1.114 1.732-5.143C9.7 0 10.825 0 10.825 0h3.897v12h-3.897V5.571h-.433L8.227 12H6.495L4.33 5.571h-.433V12H0z","fill":"#4DB45F"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_8972_158095","x1":"29.594","y1":"2.571","x2":"42","y2":"2.571","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#00B4E6"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#088CCB"}})])])])
          )
        }
      }
    